module.exports = __webpack_public_path__ + "static/media/sharepointOnline.db66b013.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/sharepointOnline.jpg
// module id = 794
// module chunks = 5